module.exports = __webpack_public_path__ + "static/logo-0b95317e4273d6b3c543a851484ebe0d.png";